export const allowedExtensionsString = {
    docx: "docx",
    doc: "doc",
    pdf: "pdf",
};
